// extracted by mini-css-extract-plugin
export var chevron = "_2y-d";
export var disabled = "_2y-b";
export var error = "_2y-c";
export var hideBorder = "_2y-1";
export var icon = "_2y-e";
export var input = "_2y-0";
export var large = "_2y-f";
export var open = "_2y-9";
export var placeholder = "_2y-a";
export var regular = "_2y-5";
export var singleRowInput = "_2y-2";
export var singleSelectInput = "_2y-3 _2y-0";
export var small = "_2y-4";
export var spinnerContainer = "_2y-i";
export var tag = "_2y-7";
export var tagsContainer = "_2y-8";
export var tagsInput = "_2y-6 _2y-0";
export var xSmall = "_2y-g";
export var xxSmall = "_2y-h";